import { render, staticRenderFns } from "./SingleNumberTailNumberNumbers.vue?vue&type=template&id=1b6a030e&"
import script from "./SingleNumberTailNumberNumbers.vue?vue&type=script&lang=js&"
export * from "./SingleNumberTailNumberNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports